<template>
  <b-container v-if="textColumns.length">
    <b-row>
      <b-col
        v-for="(textColumn, index) in textColumns"
        :key="'textColumn-' + index"
        :class="contentMargin()"
      >
        <div class="text-container" :class="contentStyle(textAlign)">
          <prismic-rich-text
            :field="textColumn.text"
            class="prismic-text-column"
          ></prismic-rich-text>
        </div>
        <div
          v-if="textColumn.buttonText && textColumn.buttonPath"
          class="text-container"
          :class="contentStyle(buttonAlign)"
        >
          <Button :to="path(textColumn)" :blank="blank(textColumn)" @click="showModal(textColumn)">
            {{ textColumn.buttonText }}
          </Button>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Button from 'UI/Button';

export default {
  components: {
    Button
  },
  props: {
    slice: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      textColumns: [],
      textAlign: '',
      buttonAlign: '',
      sideMargin: ''
    };
  },
  created() {
    const columns = this.slice.items;
    this.textAlign = this.slice.primary.text_align ? this.slice.primary.text_align : '';
    this.buttonAlign = this.slice.primary.button_align ? this.slice.primary.button_align : '';
    this.sideMargin = this.slice.primary.side_margin ? this.slice.primary.side_margin : '';
    columns.forEach((el) => {
      if (el.text_column[0]?.text) {
        const textColumn = {
          buttonBlank: el.button_blank,
          buttonPath: el.button_path && el.button_path[0]?.text,
          buttonText: el.button_text && el.button_text[0]?.text,
          openModal: el.open_modal,
          text: el.text_column
        };
        this.textColumns.push(textColumn);
      }
    });
  },
  methods: {
    blank(textColumn) {
      return !textColumn.openModal ? textColumn.buttonBlank : false;
    },
    contentStyle(align) {
      let contentClasses = '';
      if (align === 'left') {
        contentClasses = 'text-left align-items-center justify-content-start';
      } else if (align === 'right') {
        contentClasses = 'text-right align-items-center justify-content-end';
      } else {
        contentClasses = 'text-center align-items-center justify-content-center';
      }
      return contentClasses;
    },
    contentMargin() {
      return this.sideMargin === 'none'
        ? 'mx-0'
        : this.sideMargin === 'small'
        ? 'mx-2'
        : this.sideMargin === 'medium'
        ? 'mx-3'
        : 'mx-4';
    },
    path(textColumn) {
      return !textColumn.openModal ? textColumn.buttonPath : '';
    },
    showModal(textColumn) {
      if (textColumn.openModal) {
        this.$bvModal.show(textColumn.buttonPath);
      }
    }
  }
};
</script>

<style lang="scss">
.prismic-text-column {
  font-size: 16px;
  font-family: 'Poppins', sans-serif;
  letter-spacing: 0px;
  color: #707070;
  opacity: 1;
  padding-bottom: 20px;
  a {
    color: var(--exp-color);
    text-decoration: none;
  }
}

.text-container {
  display: flex;
  align-items: center;
  @include lg {
    flex-basis: auto;
  }
}
</style>
